import { setCookie, getCookie } from './cookies'

// Sets a cookie if user has already seen and closed the popup
const setPopupCookie = (cookieName) => {
    setCookie(cookieName, 'closed', document.querySelector('.li-popup').getAttribute('data-popup_setcookie'))
}

// Checks if user has already seen and closed the popup
const checkPopupCookie = (cookieName) => {
    return getCookie(cookieName) !== 'closed'
}

// Closes the popup
const closePopup = (popup) => {
    popup.classList.remove('active')
    setPopupCookie(popup.dataset.popup_name)
}

// Opens the popup if user hasn't already seen it after 5 seconds
const openPopup = () => {
    const popup = document.querySelectorAll('.li-popup')
    if (!popup.length) return
    popup.forEach(popup => {
        const delay = popup.dataset.popup_delay * 1000
        setTimeout(() => {
            if (checkPopupCookie(popup.dataset.popup_name)) {
                popup.classList.add('active')
            }
        }, delay)
    })
}

// Closes the popup on close button
const closePopupBtn = () => {
    const closeBtn = document.querySelectorAll('.close-li-popup')
    if (!closeBtn.length) return
    closeBtn.forEach(closeBtn => {
        closeBtn.addEventListener('click', (e) => closePopup(e.target.closest('.li-popup')))
    })
}

// Closes the popup if user clicks outside
const closePopupOutside = () => {
    const popup = document.querySelector('.li-popup:not(.no-close)')
    if (!popup) return
    popup.addEventListener('click', (e) => {
        if (e.target.classList.contains('li-popup')) {
            closePopup(popup)
        }
    })
}

// Initialize the popup
const initPopup = () => {
    openPopup()
    closePopupBtn()
    closePopupOutside()
}

document.addEventListener('DOMContentLoaded', initPopup)
